import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { ErrorService } from './error.service';
import { AuthService } from '../auth/auth.service';
import { LoaderService } from './loader.service';

class HttpResponseData {
  result: boolean;
  errors: string[];
  data: any;
}

@Injectable({ providedIn: 'root' })
export class HttpService {
  baseUrl: string;

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
    private authService: AuthService,
    private loaderService: LoaderService,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.baseUrl = baseUrl;
  }

  sendGet(uri: string, manualLoaderControl: boolean = false) {
    if (!manualLoaderControl) {
      this.loaderService.showLoader();
    }
    return this.http.get<any>(this.baseUrl + uri, { headers: this.getApiHeaders() }).pipe(
      map((response) => {
        return this.completeSuccess(response, manualLoaderControl);
      }),
      catchError((response) => {
        return this.completeFailed(response, manualLoaderControl);
      })
    );
  }

  sendPost(uri: string, params: any, manualLoaderControl: boolean = false) {
    if (!manualLoaderControl) {
      this.loaderService.showLoader();
    }
    return this.http.post<any>(this.baseUrl + uri, params, { headers: this.getApiHeaders() }).pipe(
      map((response) => {
        return this.completeSuccess(response, manualLoaderControl);
      }),
      catchError((response) => {
        return this.completeFailed(response, manualLoaderControl);
      })
    );
  }

  getSuccessResponse(result: any) {
    const responseData: HttpResponseData = {
      result: true,
      errors: [],
      data: result,
    };

    return responseData;
  }

  getFailedResponse(response: any) {
    let errors: string[];
    if (response.status == '400') {
      errors = this.errorService.formatErrors(response.error);
    } else {
      errors = ['Error!'];
    }

    const responseData: HttpResponseData = {
      result: false,
      errors: errors,
      data: {},
    };

    return of(responseData);
  }

  completeSuccess(response, manualLoaderControl: boolean = false) {
    if (!manualLoaderControl) {
      this.loaderService.hideLoader();
    }
    return this.getSuccessResponse(response);
  }

  completeFailed(response, manualLoaderControl: boolean = false) {
    if (!manualLoaderControl) {
      this.loaderService.hideLoader();
    }
    if (response.status == '401' || response.status == '403') {
      this.authService.redirectToAuthorizeUrl();
      return of(this.getSuccessResponse(null));
    } else {
      return this.getFailedResponse(response);
    }
  }

  getApiHeaders() {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('X-Requested-With', 'XMLHttpRequest');
    return headers;
  }
}
